import React, {
  useContext, createContext, useEffect, useState,
} from 'react';
import { PropTypes } from 'prop-types';
import { useUserFhirAPI } from 'apiServices/userFhirAPI';
import { useUserContext } from 'store';
import { oids } from 'configs';
import { useScim2API } from 'apiServices/scim2API/scim2API';
import { logDebug } from 'utils/AuxiliarFunctions';

const initialState = {
  name: 'Não Encontrado',
  dataNascimento: 'Não Encontrado',
  cns: 'Não Encontrado',
  cpf: 'Não Encontrado',
  genero: 'Não Encontrado',
  telefone: 'Não Encontrado',
  email: 'Não Encontrado',
};

const ProfileContext = createContext(
  initialState,
);

export function ProfileContextProvider({ children }) {
  const [profileState, setProfileState] = useState(initialState);
  const [user] = useUserContext();
  const [usersFhirRes, usersFhirError, usersFhirLoading] = useUserFhirAPI({ patientID: `${oids.cpf}-${user.username}` });
  const [scim2Res, scim2Error, scim2Loading] = useScim2API({ patientID: user.username });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    if ([usersFhirLoading, scim2Loading, usersFhirError, scim2Error].every((element) => element === false)) {
      let auxName = '';
      try {
        auxName = usersFhirRes.name[0].text;
      } catch (err) {
        logDebug(err);
      }

      let auxDateOfBirth = '';
      try {
        auxDateOfBirth = usersFhirRes.birthDate;
      } catch (err) {
        logDebug(err);
      }

      let auxHealthNumber = '';
      try {
        auxHealthNumber = usersFhirRes.identifier.find((idObj) => (
          idObj.system.includes(oids.cns) && idObj.use === 'official'
        )).value;
      } catch (err) {
        logDebug(err);
      }

      let auxNationalNumber = '';
      try {
        auxNationalNumber = usersFhirRes.identifier.find((element) => element.system.includes(oids.cpf)).value;
      } catch (err) {
        logDebug(err);
      }

      let auxGender = '';
      try {
        auxGender = usersFhirRes.gender;
      } catch (err) {
        logDebug(err);
      }

      let auxPhone = '';
      try {
        auxPhone = scim2Res.Resources[0].phoneNumbers[0].value;
      } catch (err) {
        logDebug(err);
      }

      let auxEmail = '';
      try {
        auxEmail = scim2Res.Resources[0].emails[0];
      } catch (err) {
        logDebug(err);
      }

      setProfileState({
        name: auxName,
        dataNascimento: auxDateOfBirth,
        cns: auxHealthNumber,
        cpf: auxNationalNumber,
        genero: auxGender,
        telefone: auxPhone,
        email: auxEmail,
      });
      setLoading(false);
    }
  }, [usersFhirLoading, scim2Loading]);
  return (
    <ProfileContext.Provider value={{ profileState, loading }}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfileContext() {
  return useContext(ProfileContext);
}

ProfileContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
